import {createContext} from 'react'

export type BasePathCtx = {
  basePath?: string
  prependBasePath: (path: string) => string | undefined
}

const BasePathContext = createContext<BasePathCtx>({
  prependBasePath: () => undefined,
})

export default BasePathContext
